import { green, red } from "@ant-design/colors"
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

type Props = {
  step: number
  checked: boolean
  onChange: (isChecked: boolean) => void
}

const checkedStyle: React.CSSProperties = {
  fontSize: '22px',
  lineHeight: '22px',
  color: green.primary
}

const uncheckedStyle: React.CSSProperties = {
  width: '22px',
  height: '22px',
  textAlign: 'center',
  color: red[3],
  border: `2px solid ${red[3]}`,
  borderRadius: '50%',
  fontSize: '16px',
  lineHeight: '18px',
}

const StepNumber = ({step, checked, onChange}:Props) => {
  const handleClick = (e: any) => {
    e.stopPropagation()
    onChange(!checked)
  } 

  return checked
    ? <div style={checkedStyle} onClick={handleClick}><FontAwesomeIcon icon={faCircleCheck} /></div>
    : <div style={uncheckedStyle} onClick={handleClick}>{step}</div>
}

export default StepNumber